// lingland-frontend/src/pages/BlogPostPage.js (POPRAWIONA WERSJA)
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Tylko ten import
import SEO from '../components/SEO';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import { ArrowRight, Tag, Clock, ChevronLeft } from 'lucide-react';
import { blogPostsData as allBlogPosts } from './BlogPageData';
import { blogContent } from './BlogContentData';
import { BlogPostCard } from './BlogPostCard';
import './BlogPostPage.css';

function BlogPostPage() {
    const { slug } = useParams();
    // Podajemy obie przestrzenie nazw, których będziemy używać
    const { t, i18n } = useTranslation(['translation', 'blog']); 
    const navigate = useNavigate();
    const [post, setPost] = useState(null);
    const [relatedPosts, setRelatedPosts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);    const [headerRef, isHeaderVisible] = useIntersectionObserver();
    const [contentRef, isContentVisible] = useIntersectionObserver();
    const [relatedRef, isRelatedVisible] = useIntersectionObserver();

    useEffect(() => {
        if (!slug) {
            setIsLoading(false);
            return;
        }

        // Znajdź post na podstawie slug
        const foundPost = allBlogPosts.find(p => p.slug === slug);
        
        if (foundPost) {
            setPost(foundPost);
            
            // Znajdź podobne posty (wszystkie oprócz bieżącego)
            const related = allBlogPosts
                .filter(p => p.id !== foundPost.id)
                .slice(0, 3);
            setRelatedPosts(related);
        }
        
        setIsLoading(false);
    }, [slug]);

    if (isLoading) { return <div className="container page-loading"><p>{t('page_loading', { ns: 'blog' })}</p></div>; }    if (!post) { 
        return ( 
            <> 
                <SEO title={t('article_not_found_title', { ns: 'blog' })} description={t('article_not_found_desc', { slug }, { ns: 'blog' })} /> 
                <div className="container post-not-found"> 
                    <h2>{t('article_not_found_title', { ns: 'blog' })}</h2> 
                    <p>{t('article_not_found_desc', { slug }, { ns: 'blog' })}</p> 
                    <Link to="/blog" className="button-secondary">{t('back_to_blog', { ns: 'blog' })}</Link> 
                </div> 
            </> 
        ); 
    }    // Logika pobierania treści
    const articleContent = blogContent[i18n.language]?.[post.slug] || blogContent['pl'][post.slug] || <p>{t('content_in_preparation', { ns: 'blog' })}</p>;
    const readingTime = 5; // Uproszczone

    // Używamy przestrzeni nazw 'blog' dla kluczy z pliku blog.json
    const title = t(`post${post.id}_title`, { ns: 'blog' });
    const excerpt = t(`post${post.id}_excerpt`, { ns: 'blog' });
    const category = t(`post${post.id}_category`, { ns: 'blog' });
    
    // ... (definicje schem bez zmian)

    return (
        <>
            <SEO title={title} description={excerpt} url={`/blog/${post.slug}`} type="article" imageUrl={post.image} structuredData={[]} />
            <article className="blog-post-page">
                <header ref={headerRef} className={`blog-post-header section-bg-light-gray animate-on-scroll ${isHeaderVisible ? 'is-visible' : ''}`}>                    <div className="container">
                        <div className="post-meta-header">
                            <button onClick={() => navigate(-1)} className="back-to-blog-link"> <ChevronLeft size={16}/> {t('back_to_blog', { ns: 'blog' })} </button>
                            <span className="post-category-header"> <Tag size={14}/> {category} </span>
                        </div>
                        <h1>{title}</h1>                        <div className="post-meta-subheader">
                            <span className="post-date"><Clock size={16}/> {t('published_on', { ns: 'blog' })} {post.date}</span>
                            <span className="reading-time"><Clock size={16}/> {t('reading_time', { ns: 'blog', time: readingTime })}</span>
                        </div>
                    </div>
                </header>

                <section ref={contentRef} className={`blog-post-content section-bg-white animate-on-scroll ${isContentVisible ? 'is-visible' : ''}`}>
                    <div className="container">
                        <div className="post-content">
                            {articleContent}
                        </div>
                    </div>
                </section>

                {relatedPosts.length > 0 && (
                    <section ref={relatedRef} className={`related-posts-section section-bg-light-gray animate-on-scroll ${isRelatedVisible ? 'is-visible' : ''}`}>
                        <div className="container">
                            <h3>{t('read_also', { ns: 'blog' })}</h3>
                            <div className="related-posts-grid">
                                {relatedPosts.map((relatedPost) => (
                                    <BlogPostCard key={relatedPost.id} post={relatedPost} />
                                ))}
                            </div>
                        </div>
                    </section>
                )}
            </article>
        </>
    );
}

export default BlogPostPage;